import { ErrorMessage } from "@hookform/error-message";
import Icons from "../../assets/Icons";
import "./ModalGarantieStyles.scss";
import { useForm } from "react-hook-form";
import Validators from "../../../utils/Validators";
import { Link } from "react-router-dom";
import { useContext, useState } from "react";
import Button from "../../components/Button";
import { routes } from "../../routes/RoutesComponent";
import ModalsContext from "../../../../domain/providers/modal/ModalsContext";
import ModalsContextType from "../../../../domain/providers/modal/ModalsContextType";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import ModalConfirmPhone from "../../pages/car/detailedCar/component/ModalConfirmPhone";
import { API_URL } from "../../../../config/env";

interface ModalCollectionOfUserDataProps {
    closeModal: () => void;
    dataOfUserSent: () => void;
    carId: string;
}

type Inputs = {
    name: string;
    phone: string;
    email: string;
    terms: boolean;
};

const formatPhoneNumber = (phone: string): string | null => {
    const digits = phone.replace(/\D/g, "");
    if (digits.startsWith("57") && digits.length === 12) return `+${digits}`;
    if (digits.startsWith("3") && digits.length === 10) return `+57${digits}`;
    return null;
};

export default function ModalCollectionOfUserData({
    closeModal,
    dataOfUserSent,
    carId,
}: ModalCollectionOfUserDataProps) {
    const { addToast } = useContext(ModalsContext) as ModalsContextType;
    const [isLoading, setIsLoading] = useState(false);
    const [isOpenModalConfirmPhone, setIsOpenModalConfirmPhone] = useState(false);
    const [error, setError] = useState(false);
    const {
        register,
        watch,
        formState: { errors, isValid },
    } = useForm<Inputs>({ mode: "onChange" }); // Added mode: "onChange" for real-time validation

    const submitForm = async () => {
        setIsLoading(true);
        try {
            const response = await fetch(
                `${API_URL}/data-user-colections/create/`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ ...watch(), phone: formatPhoneNumber(watch().phone), car: carId }),
                },
            );
            if (!response.ok) {
                throw new Error("Failed to submit form");
            }
            const data = await response.json();
            setIsLoading(false);
            window.localStorage.setItem("dataUserColection", "true");
            closeModal();
            dataOfUserSent();
        } catch (error) {
            console.error("Error:", error);
            setIsLoading(false);
            addToast("Error al enviar OTP", "error", undefined);
        }
    };
    //3153907365
    const submitFormOtp = () => {
        try {
            const formattedPhone = formatPhoneNumber(watch().phone);
            if (!formattedPhone) {
                addToast("Número de teléfono inválido. Ej: 3001234567 o +573001234567", "error", undefined);
                return;
            }
            setIsLoading(true);
            fetch(`${API_URL}/send-otp-to-phone-twilio/`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    phone_number: formattedPhone,
                }),
            })
                .then((response) => response.json())
                .then((data) => {
                    setIsLoading(false);
                    if (data?.code) {
                        setIsOpenModalConfirmPhone(true);
                    } else {
                        addToast(data?.error ?? "Ha ocurrido un error", "error", undefined);
                    }
                })
                .catch((error) => {
                    console.error("Error:", error);
                    setIsOpenModalConfirmPhone(false);
                    setError(true);
                    setIsLoading(false);
                    addToast("Error al enviar OTP", "error", undefined);
                });
        } catch (error) {
            console.warn(error);
            setError(true);
        }
    };

    return (
        <>
            <div className="box ">
                {isOpenModalConfirmPhone && (
                    <ModalConfirmPhone
                        phone={watch("phone")}
                        close={() => setIsOpenModalConfirmPhone(false)}
                        otpCode={"123456"}
                        handleConfirm={submitForm}
                    />
                )}

                <div className="closer " style={{ overflow: "scroll" }}>
                    <div className="modal-colection-user-data position-relative">
                        {isLoading && (
                            <div className="loading_container">
                                <LoadingComponent />
                            </div>
                        )}

                        <div className="icon-close" onClick={closeModal}>
                            <Icons.Clear />
                        </div>

                        <div
                            style={{
                                maxWidth: 440,
                                margin: "auto",
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    flexDirection: "column",
                                    alignItems: "center",
                                }}
                            >
                                <img
                                    className="m-auto"
                                    src="../../../../assets/icons/account2.svg"
                                    alt="lines"
                                    loading="lazy"
                                    decoding="async"
                                />
                            </div>
                            <h5 className="modal-title " style={{ color: "black" }}>
                                Regístrate gratis y accede a toda la información de los vehículos
                            </h5>

                            <form>
                                <div className="form-group my-3">
                                    <label className="mandatory">Nombre</label>
                                    <input
                                        type="text"
                                        placeholder="Ingrese su nombre"
                                        className="form-control"
                                        {...register("name", Validators({ required: true }))}
                                    />
                                    <ErrorMessage as="aside" errors={errors} name="name" />
                                </div>

                                <div className="form-group my-3">
                                    <label className="mandatory">Teléfono</label>
                                    <input
                                        type="text"
                                        placeholder="Ej: 3001234567 o +573001234567"
                                        className="form-control"
                                        {...register(
                                            "phone",
                                            Validators({
                                                required: true,
                                            }),
                                        )}
                                    />
                                    <ErrorMessage as="aside" errors={errors} name="phone" />
                                </div>

                                <div className="form-group my-3">
                                    <label className="mandatory">Email</label>
                                    <input
                                        type="email"
                                        placeholder="ingrese su email"
                                        className="form-control"
                                        {...register(
                                            "email",
                                            Validators({
                                                required: true,
                                                email: true,
                                            }),
                                        )}
                                    />
                                    <ErrorMessage as="aside" errors={errors} name="email" />
                                </div>

                                <section>
                                    <div className="form-check  mt-4">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            {...register("terms", Validators({ required: true }))}
                                        />
                                        <label className="form-check-label">
                                            Acepto tratamiento de datos personales.{" "}
                                            <Link to={"/politica-de-privacidad"} className="text_underline text_gray">
                                                {" "}
                                                Política de Tratamiento de Datos y Protección de Datos Personales.
                                            </Link>
                                        </label>
                                        <ErrorMessage as="aside" errors={errors} name="terms" />
                                    </div>
                                </section>
                                {error && (
                                    <p className="modal-title " style={{ color: "red" }}>
                                        Ha ocurrido un error al enviar el codigo a su teléfono
                                    </p>
                                )}
                            </form>

                            <div className="modal-buttons ">
                                <div
                                    className="d-flex justify-content-center justify-content-md-start p-3 "
                                    style={{ width: "70%" }}
                                >
                                    <Link
                                        to={routes.contact.relativePath}
                                        className="button-link btn btn_cyan"
                                        style={{ width: "100%" }}
                                    >
                                        CONTACTA UN ASESOR <Icons.Contact />
                                    </Link>
                                </div>
                                <Button
                                    label="Ver"
                                    iconRight={<Icons.ArrowCircle />}
                                    variant="primary"
                                    disabled={!isValid}
                                    onClick={() => submitFormOtp()}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
